import React from 'react';
interface SendProps {
  color1: string;
  color2: string;
  color3: string;
}
export const Send: React.FC<SendProps> = ({ color1, color2, color3 }) => {
  return (
    <svg viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="paint0_linear_1248_42735" x1="10" y1="14" x2="23.3227" y2="77.4666" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={color1} id="gradientStop1" />
          <stop offset="0.625" stopColor={color2} id="gradientStop2" />
          <stop offset="0.967503" stopColor={color3} id="gradientStop3" />
        </linearGradient>
        <filter id="filter0_d_1248_42735" x="0" y="0" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="-4"/>
          <feGaussianBlur stdDeviation="5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1248_42735"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1248_42735" result="shape"/>
        </filter>
      </defs>
      <g filter="url(#filter0_d_1248_42735)">
        <path d="M64 41C64 55.9117 51.9117 68 37 68C22.0883 68 10 55.9117 10 41C10 26.0883 22.0883 14 37 14C51.9117 14 64 26.0883 64 41Z" fill="url(#paint0_linear_1248_42735)"/>
      </g>
      <path d="M29.01 50L50 41L29.01 32L29 39L44 41L29 43L29.01 50Z" fill="white"/>
    </svg>
  );
};
